import visitTypes from "./constants/visitTypes.json";

/**
 * Translate a visit type id into the user's selected language.
 * @param {string} type - Visit type id (e.g. "general_consultation") or a name.
 * @returns {{translatedType: string, label: string}}
 */
const typeTranslator = (type) => {
    if (!type && type !== 0) return { translatedType: "", label: "" };

    const lang = (typeof window !== "undefined" && localStorage.getItem("language")) || "en";

    // Find by id first
    const entryByName = visitTypes.find((t) => t.nameEn === type || t.nameFr === type || t.nameAr === type || t.id === type);
    
    if (entryByName) {
        const translatedType =
            (lang === "fr" && entryByName.nameFr) ||
            (lang === "ar" && entryByName.nameAr) ||
            entryByName.nameEn ||
            type;
        const label = entryByName.nameEn || type;
        return { translatedType, label };
    }

    // If not found by id, try matching any of the names (someone may pass a name already

    // Fallback: return the input as both label and translatedType
    return { translatedType: type, label: type };
};

export default typeTranslator;